import React from 'react';
import { Advertorial } from './components/Advertorial';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="w-full bg-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <Advertorial data-id="element-2" />
    </div>;
}